/*
* Project: LegalPlace assistant
* File: src/redux/reducers/toggle_preview.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/
import { TOGGLE_PREVIEW, SHOW_POPOVER, HIDE_POPOVER } from '../actions/toggle_preview';

export function togglePreviewReducer(state = false, action) {
  if (action.type === TOGGLE_PREVIEW) return !state;
  return state;
}
export function popoverReducer(state = false, action) {
  if (action.type === SHOW_POPOVER) return true;
  if (action.type === HIDE_POPOVER) return false;
  return state;
}



// WEBPACK FOOTER //
// ./src/redux/reducers/toggle_preview.js